import { createSlice } from "@reduxjs/toolkit";
import { Site } from "../../../redux/slices/sitesSlice";
import { Client } from "../../infos-client/slices/listClientSlice";

interface PreOrderFilterState {
  siteVente: Site | null;
  siteExpedition: Site | null;
  client: Client | null;
}

const initialState: PreOrderFilterState = {
  siteVente: null,
  siteExpedition: null,
  client: null,
};

const preOrderFilterSlice = createSlice({
  name: "preOrderFilter",
  initialState,
  reducers: {
    setSiteVente(state, action) {
      state.siteVente = action.payload;
    },
    setClient(state, action) {
      state.client = action.payload;
    },
    setSiteExpedition(state, action) {
      state.siteExpedition = action.payload;
    },
  },
});

export const { setSiteVente, setClient, setSiteExpedition } =
  preOrderFilterSlice.actions;
export default preOrderFilterSlice.reducer;
